// extracted by mini-css-extract-plugin
export var box = "_65-1";
export var checkboxRow = "_65-8";
export var checked = "_65-2";
export var descriptionSpacer = "_65-a";
export var disabled = "_65-3";
export var icon = "_65-6";
export var input = "_65-0";
export var labelSpacer = "_65-9";
export var medium = "_65-5";
export var small = "_65-4";
export var text = "_65-7";